<template>
  <div>
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :count="count"
      :current="page">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
        </div>
        <div class="queryItem">
          <label>复查状态:</label>
          <lk-select class="item" clearable v-model="query.reCheckStatus" placeholder="全部">
            <lk-option v-for="(item, index) in statusMap" :key="index" :value="item[0]">
              {{item[1]}}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>创建时间:</label>
          <timeStampDatePicker type='daterange' class="item" placeholder=" 请选择" clearable v-model.trim="query.duration"/>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr" @click="handleSearch">查询</lk-button>
          <lk-button @click="handleReset">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'curingRecord',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
      'getNormalGoodsTypes',
    ]),
    hasOperate() {
      return this.handlePermission('curingReCheckView') && this.handlePermission('curingReCheckRecord');
    },
  },
  data() {
    return {
      curingRules: [],
      curingStandards: [],
      statusMap: new Map([
        [1, '等待复查'],
        [2, '已复查'],
      ]),
      query: {
        storeIdList: [],
        goodsName: null,
        reCheckStatus: null,
        duration: [],
      },
      columns: [
        {
          title: '复查单号',
          key: 'code',
          minWidth: 110,
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 110,
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 110,
        },
        {
          title: '复查状态',
          key: 'reCheckStatusStr',
          minWidth: 110,
        },
        {
          title: '复查人',
          key: 'createUserName',
          minWidth: 110,
        },
        {
          title: '复查时间',
          key: 'createTime', // 待后端确认
          minWidth: 130,
        },
        // {
        //   title: '商品类型',
        //   key: 'goodsTypeName',
        //   minWidth: 110,
        //   tooltip: true,
        // },
        // {
        //   title: '来源',
        //   key: 'purchaseTypeName',
        //   minWidth: 110,
        //   tooltip: true,
        // },
        {
          title: '操作',
          key: 'addBtn',
          minWidth: 100,
          fixed: 'right',
          render: (h, { row }) => {
            if (row.status === 2) {
              return this.handlePermission('curingReCheckView') ? h('lk-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'curingReCheckView',
                      params: { id: row.id },
                    });
                  },
                },
              }, '查看') : null;
            }
            return this.handlePermission('curingReCheckRecord') ? h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'curingReCheckRecord',
                    params: { id: row.id },
                  });
                },
              },
            }, '复查') : null;
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration && this.params.duration.length === 2) {
        this.params.startTime = this.params.duration[0];
        this.params.endTime = this.params.duration[1];
      }
      inventory.curingReCheckRecordList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          list.forEach((item) => {
            item.reCheckStatusStr = this.statusMap.get(item.status);
            item.createTime = utils.exchangeTime(item.createTime);
          });
          this.count = count;
          this.tableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleReset() {
      this.query = {};
    },
  },
  created() {
    this.handleSearch(true);
    if (!this.hasOperate) {
      this.columns.pop();
    }

    if (this.roleType !== 2) {
      this.columns.splice(0, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
};
</script>
<style lang="less" scoped>
</style>
